export default __webpack_public_path__ + "static/media/EM0790.34I-22668_-16399_0.4efb97c0.jpg";